var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedeeemVoucherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.34 24H2.00667C1.65305 24 1.31391 23.8595 1.06386 23.6095C0.813816 23.3594 0.67334 23.0203 0.67334 22.6667V1.33333C0.67334 0.979711 0.813816 0.640573 1.06386 0.390524C1.31391 0.140476 1.65305 0 2.00667 0H11.34C11.34 0.707244 11.621 1.38552 12.1211 1.88562C12.6212 2.38572 13.2994 2.66667 14.0067 2.66667C14.7139 2.66667 15.3922 2.38572 15.8923 1.88562C16.3924 1.38552 16.6733 0.707244 16.6733 0H26.0067C26.3603 0 26.6994 0.140476 26.9495 0.390524C27.1995 0.640573 27.34 0.979711 27.34 1.33333V22.6667C27.34 23.0203 27.1995 23.3594 26.9495 23.6095C26.6994 23.8595 26.3603 24 26.0067 24H16.6733C16.6733 23.2928 16.3924 22.6145 15.8923 22.1144C15.3922 21.6143 14.7139 21.3333 14.0067 21.3333C13.2994 21.3333 12.6212 21.6143 12.1211 22.1144C11.621 22.6145 11.34 23.2928 11.34 24ZM6.00667 6.66667V17.3333H8.67334V6.66667H6.00667ZM19.34 6.66667V17.3333H22.0067V6.66667H19.34Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeeemVoucherIcon);
export default __webpack_public_path__ + "static/media/redeeemVoucherIcon.9d86188b767004334cc7001cd1143ea4.svg";
export { ForwardRef as ReactComponent };